module.exports = __webpack_public_path__ + "static/media/044-communications.dfa22a55.svg";